import React, { useEffect, useRef, useState } from "react";
import DialogWrap, { DialogWrapLogin } from "../../controls/components/dialogWrap/DialogWrap";
import FomrmLogin from "./component/FormLogin";
import FomrCreateOne from "./component/FormCreateOne";

export default function DialogCreateOne(props: {
	openDialog: boolean;
	setOpenDialog: (value: boolean) => void;
	setOpenDialogLogin: (value: boolean) => void;
}) {
	return (
		<DialogWrapLogin
			login={true}
			hideFooter={true}
			open={props.openDialog}
			onClose={() => {
				props.setOpenDialog(false);
			}}
			title="Create new account">
			<FomrCreateOne
				setOpenDialog={props.setOpenDialog}
				setOpenDialogLogin={props.setOpenDialogLogin}
			/>
		</DialogWrapLogin>
	);
}
